import React from 'react';
import { Avatar, Dropdown } from 'antd';
import { UserOutlined, LogoutOutlined, DownOutlined } from '@ant-design/icons';
import { logout } from '../../authService';

const UserDropdown = ({ user }) => {
  const handleLogout = () => {
    logout();
  };

  const items = [
    {
      key: 'user',
      icon: <UserOutlined />,
      label: (
        <div>
          <div style={{ textTransform: "capitalize", fontWeight: "600" }}>
            {(user?.user_info?.name || "User")
              .replace(/\bnull\b/gi, "")
              .trim()}
          </div>
          <div style={{ fontSize: '12px', color: '#888' }}>
            {user?.user_info?.email || ''}
          </div>
        </div>
      ),
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: handleLogout,
    },
  ];

  return (
    <div style={{ float: "right" }}>
      <Dropdown menu={{ items }} trigger={['click']}>
        <div
          style={{
            marginRight: '20px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            cursor: 'pointer'
          }}
        >
          <Avatar style={{ backgroundColor: '#8c3add' }}>
            {user?.user_info?.name?.charAt(0)?.toUpperCase()}
          </Avatar>

          <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2' }}>
            <span><b>{(user?.user_info?.name || "User")
              .replace(/\bnull\b/gi, "")
              .trim()}</b></span>
            <span style={{ fontSize: '12px', color: '#888', marginTop: "3px", fontWeight: "600" }}>
              Admin
            </span>
          </div>

          <DownOutlined style={{ color: "#888", fontSize: "12px" }} />
        </div>
      </Dropdown>
    </div>
  );
};

export default UserDropdown;